/**
    商品列表
**/
<template>
  <div class="rightaside_content">
    <h3 class="headerTitle">店铺收藏</h3>
    <el-row :gutter="20"  v-loading='loading'>
      <el-col :span="6" v-for="item in goodsList" :key="item.id">
        <div class="wholeInfoBox">
          <div>
            <el-image :src="item.merchant.logo" @click="$router.push(`/shopStore?storeId=${item.merchant.bxmId}`)">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <div class="attentiontOpreate">
              <el-button type="warning" @click="addCollectionHandle(item.merchant.bxmId)"  v-if="item.merchant.isCollect==0?true:false" icon="el-icon-star-off" circle></el-button>
              <el-button type="warning" @click="removeCollectionHandle(item.merchant.bxmId)" class="star_on" v-if="item.merchant.isCollect==1?true:false" icon="el-icon-star-on" circle></el-button>
              <!-- <el-button type="warning"  icon="el-icon-star-off" circle></el-button>
              <el-button type="warning" class="star_on" icon="el-icon-star-on" circle></el-button> -->
              
            </div>
            <div class="goodsText">
              <router-link :to="`/shopStore?storeId=${item.merchant.bxmId}`"
                ><p class="OneLineDisplay" style="font-size:16px">{{ item.merchant.name }}</p></router-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col v-if="goodsList.length == 0 ? true : false">
        <div class="no_goods">
          <el-image :src="require('@/assets/img/no_goods.png')" fit="fill">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <p>暂无您的收藏店铺</p>
          <p>可以去看看哪些想收藏的</p>
          <router-link to="/"
            ><p class="OneLineDisplay">随便逛逛</p></router-link
          >
        </div>
      </el-col>
    </el-row>   
  </div>
</template>
<script>
import goodsCard from '@/components/goodsCard'
import {collection_list,addCollection,removeCollection } from "@/api/xunyou";
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      loading:false,
      goodsList: [
        {
          id: 1,
          name: "鱼尾旗袍新款改良复古修身蕾丝中式旗袍 黄色 蕾丝",
          realprice: 368,
          evaluator: 3,
          photos: require("@/assets/images/commend1.jpg"),
        },
        {
          id: 2,
          name: "鱼尾旗袍新款改良复古修身蕾丝中式旗袍 黄色 蕾丝",
          realprice: 368,
          evaluator: 3,
          photos: require("@/assets/images/commend1.jpg"),
        }
      ],
      info: {
        searchValue: null,
        createBy: "",
        createTime: "2020-11-27 15:28:07",
        updateBy: "",
        updateTime: null,
        remark: "",
        params: {},
        id: 17,
        cid: "10",
        sid: "1",
        tag: "",
        name: "有机西兰花绿花椰菜新鲜有机蔬菜宝宝辅食 200g",
        adWord: "中国欧盟美国有机认证 农场现摘 品质保障",
        type: 1,
        photos:
          "/profile/upload/2020/11/27/4653959cf45dc8c6cb6ee84bb7c3e3f6.jpg",
        video: "",
        marketprice: "16",
        realprice: "16",
        needPoints: "200",
        stock: "9999",
        serialNumber: "",
        description: "有机西兰花绿花椰菜新鲜有机蔬菜宝宝辅食 200g",
        deliveryPlace: "安徽省",
        postage: "10",
        maxNum: 0,
        addedTime: "2020-11-27 00:00:00",
        buttonName: "",
        status: 1,
        addShelfSwitch: null,
        mid: 30,
        brandId: "",
        exchangeValue: null,
        pointsPrice: 10,
        producttype: "",
        attributes: "",
        salesnum: "",
        uid: null,
        approvalStatus: 1,
        number: null,
        cart_select: null,
        scid: null,
        checked: false,
      },
      goodsSize: "",
      num1: 1, //商品数量
      getprovince: [], // 地址联动
      cascaderAreaValue: [], // 发货地址
      shippingAreaValue: [], // 收货地址
    };
  },
 // 注册组件
  components: {goodsCard},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted() {
    this.getcollectionList();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
       // 查询收藏的店铺
  getcollectionList() { 
    if(this.userInfo.userId==undefined){
            this.$message.error("请登录！");
            setTimeout(()=>{
              this.$router.push('/login')
            },2000)
            return
          }   
    this.loading = true;
    const req = {
      type:2, //type:1:商品；2：店铺  
      uid:this.userInfo.userId||''
    }
      collection_list(req)
        .then((res) => {
          if (res.code == 0) {
            this.loading = false;
            this.goodsList = res.rows;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("我的足迹查询失败，请稍后再试！");
        });
    },
    // 添加关注
    addCollectionHandle(id) {
      if(this.userInfo.userId==undefined){
            this.$message.error("请登录！");
            setTimeout(()=>{
              this.$router.push('/login')
            },2000)
            return
          }
      // this.loading = true;
      const req ={
        type:2, //1:商品；2：店铺；必填
        uid:this.userInfo.userId,
        cid:id, // 店铺id
      }
      addCollection(req)
        .then((res) => {
          if(res.code == 0){
            this.getcollectionList()
          }
        })
        .catch((err) => {
          this.$message.error("关注失败，请稍后再试！");
        });
    },
    // 取消关注
    removeCollectionHandle(id) {
      // this.loading = true;
      const req ={
        type:2, //1:商品；2：店铺；必填
        uid:this.userInfo.userId,
        cid:id, // 店铺id
      }
      removeCollection(req)
        .then((res) => {
          if(res.code == 0){
            this.getcollectionList()
          }
        })
        .catch((err) => {
          this.$message.error("关注失败，请稍后再试！");
        });
    },
    //   打开商品详情弹框
    openGoodsInfo() {
      console.log("打开", this.openGoodsVisible);
      this.openGoodsVisible = true;
    },
    beforeClose() {
      console.log("关闭", this.openGoodsVisible);
      this.openGoodsVisible = false;
    },

    // 选规格价格发生变化
    getgoodsSize(value, updateprice) {
      this.info.realprice = value;
      // this.updateprice = updateprice;
    },
    // 计数量
    handleChange(value) {
      console.log(value);
      // this.info.marketprice = value*this.info.marketprice;
    },

    // 加入购物车
    onAddCar(id, number, bXySid) {
      // if(this.userInfo.userName==null||this.userInfo.userName=="" ){
      //   this.$router.push('/login')
      //   return
      // }
      // if(this.goodsSize == ''){
      //   this.$message({
      //      type: 'info',
      //      message: '请选择规格'
      //    })
      //    return
      // }
      //  addShoppingCart({
      //   cid: id,
      //   uid: this.userInfo.userId,
      //   number:number,
      //   bxysid:this.goodsSize
      // })
      //   .then((res) => {
      //       if (res.code == 0) {
      //         console.log("res", res);
      //         this.addDialogVisible = true;
      //       }
      //   })
      //   .catch((err) => {
      //     this.loading = false;
      //     this.$message.error("添加购物车失败，请稍后再试！");
      //   });
    },
    // 立即下单
    orderNow() {
      // let selectList = [];
      // let goodList = [];
      // goodList.push({
      //   ...this.info
      // })
      //  let obj = {
      //   name:this.info.name,
      //   goods:goodList
      // }
      //  selectList.push(obj)
      //  sessionStorage.setItem("selectList", JSON.stringify(selectList));
      //  this.$router.push('/orderDetail')
    },

    //   加入购物车
    addCart(id, name, specificationlist) {
      this.addDialogVisible = true;
      // addShoppingCart({
      //     cid: id,
      //     uid: this.userInfo.userId,
      //     number: 1,
      //     bxysid:specificationlist.length>0?specificationlist[0].bXySid:''
      // })
      //     .then((res) => {
      //         if (res.code == 0) {
      //         console.log("res", res);
      //         this.addGoodsName = name;
      //         this.centerDialogVisible = true;

      //         }
      //     })
      //     .catch((err) => {
      //     this.loading = false;
      //     this.$message.error("添加购物车失败，请稍后再试！");
      //     });
    },
  },
};
</script>

<style scoped lang="less">
.rightaside_content {
  .headerTitle {
    font-size: 20px;
    height: 40px;
    line-height: 40px;
    color: #666;
    margin-bottom: 20px;
  }
  /deep/.el-tabs--border-card {
    border: 0px;
    box-shadow: unset;
    .el-tabs__header {
      border-bottom: 0px;
      background: white;
      /deep/ .el-tabs__item.is-active {
        color: #78b942;
        background-color: transparent;
        border-right-color: transparent;
        border-left-color: transparent;
      }
    }
  }

 .wholeInfoBox {
    // width: 80%;
    height: auto;
    border: 1px solid #e4e4e4;
    padding: 10px;
    box-sizing: border-box;
    position: relative;
    
    .attentiontOpreate {
      display: none;
      position: absolute;
      right: 10px;
      top: 10px;
      .el-button--warning {
        color: #fff;
        background-color: rgba(0, 0, 0, 0.4);
        font-size: 16px;
        border-color: transparent;
        display: block;
        margin-left: 0 !important;
        margin-bottom: 10px;
      }
      button.el-button.el-button--warning.is-circle.star_on {
          background-color: rgb(255 103 0) !important;
      }
    }
    .el-image {
       width: 169px;
        height: 169px;
        background: #f5f5f5;
        cursor: pointer;
        position: relative;
        /deep/.image-slot {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
      }
    }
    .goodsText {
      text-align: center;
      margin-bottom: 4px;
    }
    .mark {
      display: none;
      font-size: 14px;
      background: rgba(255, 255, 255, 0.8);
      position: relative;
      .redeemNow {
        background: #78b942;
        padding: 6px;
        text-align: center;
        color: white;
        cursor: pointer;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        border-radius: 6px;
      }
      .redeemNow:hover {
        background-color: rgba(34, 34, 34, 0.85);
      }
    }
  }
  .wholeInfoBox:hover {
    .attentiontOpreate {
      display: block;
      cursor: pointer;
    }
    .el-button--warning:hover {
      background: #78b942;
    }
  }
 

  .no_goods {
    text-align: center;
    line-height: 24px;
    font-size: 14px;
  }
}
// }
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/myOrder/attentionCenter/shopCollection.vue